import React, { useCallback, useState } from 'react';
import { Tappable } from '@vectord/components';
import { TypeUtils } from '@vectord/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function EditableSection({
  title,
  canEdit,
  className,
  titleClassName,
  handleOnChange,
  children,
  actions,
}) {
  const [isEditing, setIsEditing] = useState(false);

  const toggleEditing = useCallback(() => {
    setIsEditing((prevIsEditing) => !prevIsEditing);

    if (TypeUtils.isFunction(handleOnChange)) {
      handleOnChange(setIsEditing);
    }
  }, [handleOnChange]);

  return (
    <div className={className}>
      <div className="m-b-xxs">
        <label className={classNames('hint', titleClassName)}>{title}</label>
        {canEdit && (
          <Tappable
            className="primary h5 m-l-m"
            noHighlight
            onClick={toggleEditing}
          >
            {isEditing ? 'Cancel' : 'Edit'}
          </Tappable>
        )}
        {actions}
      </div>
      {children({ isEditing, setIsEditing })}
    </div>
  );
}

EditableSection.propTypes = {
  title: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
};
